(function($) {

  $(document).ready(function() {		
    backclub.init();		
  });

  var backclub = {
    backclubTimeout: null,
    isSidebarAjaxClick: false,
    init: function() {	
      this.window_resize();
      this.header();
      this.slider();
      this.jquery_ui();
      this.read_more();
      this.newslatter();
    },

    window_resize: function(){
      $(window).load(function(){
        backclub.resizeContent(); 
        $(window).resize(function() {
          backclub.resizeContent();
        });
      });
    },

    newslatter : function(){

      // ----------------- Newsletter popup ---------------

      $(window).load(function(){
        setTimeout( function() {
          var check_cookie = $.cookie('mailing_list_popup');
          $('.newsletter_overlay .close').click(function(e) {
            $.cookie('mailing_list_popup', '1', { expires: 15 });
            $(".newsletter_overlay").hide();

          });

          if(check_cookie == null){
            $.cookie('mailing_list_popup', '1', { expires: 15 });
            $(".newsletter_overlay").show();

          }


          else if(check_cookie < 1){
            x = $.cookie('newsletter_overlay');
            y = 1;
            var z = +x + +y;
            $.cookie('newsletter_overlay', z, { expires: 15 });
            $(".newsletter_overlay").show();

          }

        }, 3000);
      });

    },

    read_more: function(){
      $('.read_more').click(function(e){
        e.preventDefault();
        $(this).closest('.excerpt_div').hide();
        $(this).closest('.excerpt_div').siblings('.expanded_div').show();
      });

      $('.read_less').click(function(e){
        e.preventDefault();
        $(this).closest('.expanded_div').hide();
        $(this).closest('.expanded_div').siblings('.excerpt_div').show();
      });
    },

    resizeContent: function(){

    },

    header: function(){			

      var header_height = $("#header").height() + 20; 
      var header_height_effect = $("#header").height() + 50;
      $(window).scroll(function() {
        var windowpos = $(window).scrollTop();
        if (windowpos > header_height) {
          $('#header').addClass('sticky_nav_up');
        } else {
          $('#header').removeClass('sticky_nav_up')
        }
        if (windowpos > header_height_effect) {
          $('#header').addClass('sticky_nav');
        } else {
          $('#header').removeClass('sticky_nav')
        }
      });


      //-------------------  meanmenu 			
      jQuery('header nav').meanmenu();


      $(".meanmenu-reveal").click(function(e) {
        $('body').toggleClass('menu_hidden');
      });

      //----------------- SEARCH TOGGLE        

      $(".search_icon").click(function(e) {
        $('.search_form form').toggleClass('show_form');				
      });

      $('html').click(function() {
        $('.search_form form').removeClass('show_form');
      });

      $('.search_form , .search_form form').click(function(event){
        event.stopPropagation();
      });     
      
    

      //----------------- DROPDOWN OVERLAY

      $('#main-nav > ul > li').hover(function(){
        if($(this).find('.menu_dropdown, .has_sub').length){
          $('body').addClass('menu_overlay');
        }
      }, function() {
        $('body').removeClass('menu_overlay');
      });

    },


    slider: function(){			
      //-------------------  slider 
      $('.slider').bxSlider({
        mode: 'fade',
        auto: true,
        controls:false,
        pause: 4000
      });

      $('.classes_main_img').bxSlider({
        pagerCustom: '#classes_thumb',
        controls:false,
      });
      $('.classes_main_img_mobile').bxSlider({
        pagerCustom: '#classes_thumb_mobile',
        controls:false,
      });

      $('.partners_list').owlCarousel({
        loop:true,
        margin:18,
        nav:false,
        dots:false,
        auto:true,
        responsive:{
          0:{
            items:2
          },
          480:{
            items:3
          },
          600:{
            items:4
          },
          992:{
            items:6
          }
        }
      });

      $('.related_classes .grid').owlCarousel({
        loop:false,
        margin:18,
        nav:false,
        dots:false,
        responsive:{
          0:{
            items:1,
            margin:10,
            dots:true,
          },
          481:{
            items:2,
            margin:10,
            dots:true,
          },
          768:{
            items:3
          }
        }
      })
    },

    jquery_ui: function(){
      $( "#classes_description, #bakers_details, #for_me, #book_description").tabs({
        collapsible: true
      });
      $("#topic_tab").accordion({
        heightStyle: "content",
        collapsible: true
      });
      $("#payment_tab").accordion({
        heightStyle: "content",
        collapsible: true
      });
      $( "#equipment_tab").accordion({
        heightStyle: "content",
        collapsible: true
      });
    },
  }

  })(jQuery);


// ================================== FOR STICKY NAV




